import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  display: flex;\n  padding: 24px 24px 0px 24px;\n  background: ",
        " !important;\n  /* position: relative; */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  flex: 1;\n  justify-content: center;\n  color: #23262f;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 36px;\n  gap: 10px;\n  padding-top:5px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  flex-direction: column;\n  max-height: 80vh;\n  overflow-y:auto;\n  padding:24px!important;\n  &::-webkit-scrollbar-thumb {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  flex-direction: column;\n  max-height: 100vh;\n  overflow-y:auto;\n  padding:0px!important;\n  &::-webkit-scrollbar-thumb {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background: black !important;\n  border-radius: 50%;\n  height: 40px;\n  width: 40px;\n\n  svg {\n    fill: #fff;\n    width: 25px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  overflow: hidden;\n  background: ",
        ";\n  box-shadow: 0px 20px 36px -8px rgba(14, 14, 44, 0.1), 0px 1px 1px rgba(0, 0, 0, 0.05);\n  border: 1px solid ",
        ";\n  border-radius: 20px;\n  width: 100%;\n  max-height: 100vh;\n  z-index: ",
        ";\n  ",
        " {\n    width: auto;\n    min-width: ",
        ";\n    max-width: 100%;\n  }\n  padding:0px;\n  padding-top:1rem;\n  @media screen and (max-width: 500px) {\n    padding: 0px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    background: black;\n    border-radius: 50%;\n    height: 40px;\n    width: 40px;\n    z-index: 99;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Flex from "../../components/Box/Flex";
import { MotionBox } from "../../components/Box";
import { ArrowBackIcon, CloseIcon } from "../../components/Svg";
import { IconButton } from "../../components/Button";
export var ModalHeader = styled.div.withConfig({
    componentId: "sc-3fc512e3-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
export var ModalTitle = styled(Flex).withConfig({
    componentId: "sc-3fc512e3-1"
})(_templateObject1());
export var ModalBody = styled(Flex).withConfig({
    componentId: "sc-3fc512e3-2"
})(_templateObject2());
export var ModalBodyV2 = styled(Flex).withConfig({
    componentId: "sc-3fc512e3-3"
})(_templateObject3());
export var WrapIconButton = styled(IconButton).withConfig({
    componentId: "sc-3fc512e3-4"
})(_templateObject4());
export var ModalCloseButton = function(param) {
    var onDismiss = param.onDismiss;
    return /*#__PURE__*/ _jsx(WrapIconButton, {
        variant: "text",
        onClick: onDismiss,
        "aria-label": "Close the dialog",
        style: {
            zIndex: "1"
        },
        children: /*#__PURE__*/ _jsx(CloseIcon, {
            color: "white"
        })
    });
};
export var ModalBackButton = function(param) {
    var onBack = param.onBack;
    return /*#__PURE__*/ _jsx(IconButton, {
        variant: "text",
        onClick: onBack,
        "area-label": "go back",
        mr: "8px",
        children: /*#__PURE__*/ _jsx(ArrowBackIcon, {
            color: "white"
        })
    });
};
export var ModalContainer = styled(MotionBox).withConfig({
    componentId: "sc-3fc512e3-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.zIndices.modal;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var minWidth = param.minWidth;
    return minWidth;
});
export var ModalCloseButtonUnbox = function(param) {
    var onDismiss = param.onDismiss;
    return /*#__PURE__*/ _jsx(Cusbutton, {
        variant: "text",
        onClick: onDismiss,
        "aria-label": "Close the dialog",
        children: /*#__PURE__*/ _jsx(CloseIcon, {
            color: "#ffffff"
        })
    });
};
var Cusbutton = styled(IconButton).withConfig({
    componentId: "sc-3fc512e3-6"
})(_templateObject6());
